<template>
  <div class="map" id="container">
  </div>
</template>
<script>
//地图设备点经纬度
let long;
let lan;
let marker;
export default {
  props: {
    long: {
      type: String
    },
    lan: {
      type: String
    }
  },
  data() {
    return {
      MarObj: null
    }
  },
  mounted() {
    //异步创建地图与坐标
    long = this.long
    lan = this.lan
    if (long && lan) {
      //实例化地图
      this.MarObj = new AMap.Map('container', {//'map-location'是对应页面盒子的id
        resizeEnable: true,
        center: [long, lan],
        zoom: 15,
        zooms: [3, 20],
        expandZoomRange: true,
        viewMode: '3D'
      })
      //添加设备坐标
      marker = new AMap.Marker({
        position: new AMap.LngLat(long, lan)
      })
      //绑定地图点击事件
      this.MarObj.on('click', function (e) {
        //获取经纬度
        long = e.lnglat.getLng()
        lan = e.lnglat.getLat()
        // //删除原点
        // MarObj.remove(marker)
        // //创建点
        // marker = new AMap.Marker({
        // position: new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat())
        // })
        marker.setPosition([e.lnglat.getLng(), e.lnglat.getLat()])
      })
      new AMap.plugin([
        'AMap.Scale',
        'AMap.ToolBar'
      ], function () {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        this.MarObj.addControl(new AMap.ToolBar())
        // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
        this.MarObj.addControl(new AMap.Scale())
      })
      //添加点至地图
      this.MarObj.add(marker)
    }
  },
  methods: {
    //提交经纬度
    GetMap() {
      return { long, lan }
    },
    //重置按钮
    ResetLatLng() {
      console.log()
      marker.setPosition([Number(this.long), Number(this.lan)])
    }
  },
  // deactivated() {
  //   // 销毁地图
  //   this.MarObj && this.MarObj.destroy()
  // }
}
</script>
<style scoped>
.map {
  width: 100%;
  margin: 0 auto;
  display: inline-block;
  height: 50vh;
}
</style>
